import React from "react"
import Logo from "./logo"
import {Link} from "gatsby"
import { OutboundLink } from "gatsby-plugin-google-gtag-optin"
import { FiPhoneCall, FiInstagram ,FiFacebook, FiMapPin,FiMail} from "react-icons/fi";
import { FaPinterestP } from 'react-icons/fa';
import { useStaticQuery, graphql } from "gatsby"
import slugHandler from "../api/slugHandlerBrowser"
import CookieConsent from "./cookie-consent/CookieConsent";
function Footer(props) {
    const data = useStaticQuery(graphql`
    {
      posts: allMdx(filter: {frontmatter: {templateKey: {eq: "post"}, tags: {regex: "/news/"}}}, sort: {fields: [frontmatter___date], order: DESC}) {
        nodes {
          slug
          id
          frontmatter {
            date(formatString: "DD MMMM YYYY")
            title
          }
        }
      }
      settings: file(sourceInstanceName: {eq: "settings"}, name: {eq: "settings"}) {
        childMdx {
          frontmatter {
            detectLanguage
            email
            facebook
            sitename
            address
            address2
            hours
            phone
            instagram
            twitter
            googlemaplink
            googlemaphtml
            pinterest
          }
        }
      }
    }
  `)
  const posts = data.posts.nodes
  .filter(post => {
    const lang = post.slug.split(".")[1];
    return lang === props.lang;
  }).slice(0,3);
  // const footerTexts = props.translation.footer;
  const nav = props.translation.nav;
  const settings = data.settings.childMdx.frontmatter;

  const { email, instagram, facebook, phone, address, address2, googlemaplink, pinterest  } = settings;
    const year = new Date().getFullYear();
    return (
        <section className="footer container-1200">
            {/* <div className="footer-line mb1">

            <svg width="1280" viewBox="0 0 1280 26" fill="rgb(var(--color-text))" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
              <path d="M807 9V8h-1l1 1zm85 1V9v1zm-47 3h-1 1zm4-4h-1 1zm171 9l-1-1v1h1zm-23-6h-1 1zm-10 0h-1 1zm-3 0h0zM602 6zm362 5h0zm-18 1zm0 3l1-1h-1v1zm-42-2zm39-1zm-1 0h-1 1zm-1 1h0zm0 1zM685 8V7v1zm253 3zm-10 1zm-148 0h-1 1zm334 8h0zm87-4h1-1zm44 2h-1 1zm18 1zm-342-9h-1 1zm10 1h0zm10 3l-1-1v1h1zm8-2l-1-1v1h1zm36 4h-1-1l1 1 1-1zM755 7h-1-1l1 1 1-1zM249 1l1-1h-1v1zm677 13h2v-2c1 0 0 0 0 0h-1v1h-1l-1-1v1l1 1zm23-1h-1l-2-1h-1l-1 2h4l1-1zm8 1h1l1-1h1l1-1 1-1h-2l-3 2h-1l1 1zm-23-2h-1-2l1 1-1 1h1l1-1 1-1h1v1l2 1v-1h2l-3-1h-1-1zm18 1h-1 1zm5-1h-1c-1 1-2 1-1 2h-3c-1 0 0 0 0 0l-2-1h-1l2-1c2 0 3 1 4-1l2 1zm136 6h-1 1zm-12-2v1h1l-1-1zm-1 0h-1 1zm-3-1h-1 1zm-23 3h1l-1-1v1zm-3-1zm-29-3zm-2 2h-1 1zm-3 0v0zm-4-3zm-6 4v-1 1zm-3-1h1-1zm-3-1h-1v1l1-1zm-3-1zm1 1h-1v1l1-1zm-13-2zm123 5h0zm32-1zm1 0v1l1-1h-1zm72 0h-1 1zm3 2h-1 1zm15-1zm29 6v-1l-1 1h1zm8-1h0zm2-1h1-1zm-300-9h-1 1zm5 1h2l-1-1-1 1zm20-1l1 1v-1h-1zm4 2l1-1h-1v1zm24 2h1v-1l-1 1zm1-3l-1-1v1h1zm18 2v-1h-1l1 1zm133 3v-1h-1l1 1zm50-1v0zm-245-5h-1 1zm-8 1h1l-1-1h-1l1 1zm219 7h2v-1l-2 1zm-172-5h1-2-1 2zm3 0l1-1-1 1zm-44-1h2v-1l-2 1zm-4-2c1 0 0 0 0 0v1h-1l1-1zm109 2h0l1 1v-1 1l-1-1zm117 1l1 1h8l1-1h1l3 1h6l3 1h28l2 1h6l2 1h2l1 1-1-1v1h1l1-1 2 1 4-1 2 1h6v1h-1c1 1 0 2-1 2h-6l-3 1h-11l-2-1h-9l-6 1h-1l-1-1h-1-1l-2-1h-3l-1 1-1-1-2-1h-7-2-2-19l-2-1-5 1-3-1h-15-8-3l-1-1s1 0 0 0l-3 1h-4l-2-1h-22-21-1-7l-2-1h-4 1-15-9-6l-3-1h-13-7-4l-3-1h-6-2l-3 1-3-1h-1 1l-2 1v-1h-16-2l-2-1h-6 1-3l-1-1h-1l-1 1h-4-6l-3-1h-4-2-2c-1 0 0 0 0 0v-1h-1l1-1h1v-1h-1l-1 1-1 1-1 1h-1l-2-1v-1l2-1c1 0 1 0 0 0l3-1 2 1 2-1 1 1h4c0 1 0 1 0 0h6l2 1h3c1 0 1 0 0 0v1h1v-1h1a180 180 0 015 0c-1 0 0 0 0 0h-1 1l3-1h3l1 1c-1 0 0 0 0 0h1l3-1h5l7 1h24l2 1h10l6 1 7-1h3l2 1 3-1 3 1 4-1 4 1h17l9 1 2-1v1h1l3-1h3l5 1 2-1 3 1h17l1-1 1 1h4c0-1 0 0 0 0h17l2 1h1l2-1 2 1h22l2-1zM15 3h1-1zm1-1l1 1V2h-1zm5 1h1-1zm1-1zm12 0v0zm26 4v0zm7-4l1 1V2h-1zm4 4h-1 1zm4 1zm7-5zm1 4zm0-1h-1 1zm1-1h0zm4-1zm25 1zm8 3zm7-3h-1 1zm684 8l1-1h-1v1zm0-3h1-1zM134 6zm5-4v0zm11 1zm14 4h1-1zm653 2V8v1zm1 3h-1 1zM180 2zm16 1zm9-1V1v1zm15 1V2l-1 1h1zm670 10v-1 1zm-54-1zm3 0h-1 1zM401 9l-1-1v1h1zm25-4V4v1zm25 4zm45 1zm68-3h1l-1-1v1zm345 4zm-58 0v-1h-1l1 1zm-248-1zm257 0zm1 3v-1 1zM636 9h-1v1l1-1zm0 1zm1-3zm18 2h0zm247 3v0zm-244-1h1-1zm3-1zm18 0h0zm1-2h-1l1 1V8zm6 1s-1 0 0 0zm30 2h-1 1zm7 0zm169 0h-1 1zm-127-1h1-1zm10 0h-1 1zm112 1l1 1v-1h-1zm-97 0zm3 0l1 1v-1h-1zm-39-1h-1 1zm28-1l1-1h-1v1zm49 2v-1 1zm13-1h1V9l-1 1zm15 1h1l-1-1-1 1h1zm5 0v-1l-1 1h1zm23 1v0zm18-1h1-1zm3 1h-1 1zM98 4h-1 1zm2 1V4v1zm32-1v1h1V4h-1zm2-1l-1 1h1V3zm19 3V5h-1l1 1zm47-4l1-1h-1v1zm216 6h0zM103 5h1-1zm638 6l-1-1v1h1zm157 2l1-1h-1v1zm-239-3h0zm234 1h0zM468 8h1V7h-1v1zM159 5h-2 2zM72 3h1V2l-1 1zM18 7h-2 2zm137-2h-1v1h2V5h-1zm389 4v1h1V9l-1-1v1zm370 3v-1l-2 1h2zM552 7h-1-1l-1 1 1 1 2-2zm107 2h1V8h-2v1h1zm224 4h-1-1 2zM249 1h10l1 1h11l4-1h1l1 1h32l2 1 1-1 7 1h20l2-1h13l4 1h34v0h4l1 1h16l5 1h3l4-1h24l3 1h4l2-1h1l8 1h23l4-1h1c1 1 0 2 1 1h17l7 1h6l2-1h6l1 1h2l1-1 4 1h1l2-1h1l3 1h4V5h2l2 1h42v1h1l1-1h1v0h12l1 1 1-1h1v0h2l3 1h1l2-1 2 1 8-1h5l2 1h2l4-1 3 1h-1 9l3-1 3 1h12l3 1 1-1h3l1 1 3-1h2c2 0 1 1 1 1h2V7h11v1l1-1h12l4 1h1l2-1h26l2 1v1h6l1-1h-1l-1 1s-1 0 0 0h1v1l1-1h-1c0-2 2-1 2-1v1h1l2-1h15l-2 1v1h1V9c-1 0-1 0 0 0h1l2-1h12c-2 0-1 0 0 1h9v1h1V9l2-1 3 1h1l6-1c0 1 0 0 0 0v0h8l2 1h1l1-1h1l1 1h8l1-1 2 1c1 0 0 0 0 0h10l1 1h1l2-1h1l3 1h1l2-1h5l1 1 2-1h9l2 1h1l2-1h1l3 1h10l2 1v-1h4c1 1 1 0 0 0l1 1-1-1h14v1l2 1h1l-1-1-1-1h4l1 1h-1-1l2 1h2v-1h3l-1 1h-4l-2 1h-3-2l-2 1h-5-1l-2-1v-1 0l-2 1h-3l-2 1h-2l-6-1-4 1h-4l-2-1h-35-1-5-12-13l-6-1h-3l2-1h-1s-2 0-1 1h-3s-1 0 0 0l-1 1v-1h-5-4l-2-1-1 1-3-1h-2-4-2-1l1-1h-2v1l-2 1h-2v-1h-4-1a37 37 0 00-9 0h-1-1-1l-5 1h-3l-3-1h-2l-2 1-6-1h-8v1l-5-1-4 1h-7l-2-1h-1l-2 1-3-1h-5l-1 1h-2l-1-1h-1l-3 1h-2l-7-1-3 1-2-1-4 1h-2l-1-1h-4-3l-2 1h-4-2l-4-1h-7-2-5-6-6-1-4-3-1-2c-1 0 0 0 0 0h-1-1l-2 1h-7l-4-1h-4-1-7l-4 1-8-1h-2-3l-3-1h-2l-7 1h-10-18l-2-1h-4-1-3l-3 1h-7l-2-1h-2l-4 1h-1l-1-1h-16-1-13l-1-1-2 1h-6-21-1l-3-1h-9-6 0-15-15l-2-1h-7-12l-2 1h-1l-3-1h-14-1-4l-1 1-4-1h-12c0-1 0 0 0 0h-6l-4-1h-1l-1 1h-14-2-1l-3-1h-8-1-1l-5 1h-4V7h-1l-2 1s-2 0 0 0h-3l-2-1h-13l-3 1h-19-4l-4-1h-6-10-5-1l-4-1h-3l-5 1h-3-2-2l-1-1v1h-10-20c-2 0 0 0 0 0h-30-5l-1-1h-6l-1 1h-7-1-1l-2-1h-4s-3 0-1-1h-1l-2 1h-2-1l-2 1h-4c-2-1-3 0-5 1h-1l-2-1-2 1-1-1h-3-7-15-2l-5 1h-1-22-3-7-2 1V7H1L0 6l1-1 2-2h2l1-1h5V1l3 1 2-1h8l1 1h1l3-1h21l4 1 3-1h5l5 1h2V1h10v1h73l4-1h5l3 1h2l2-1h7l2 1 3-1h6l2 1h7l2-1h28l1 1h5l6-1h1l4 1 4-1h3z" fill="inherit" fillRule="evenodd"/>
            </svg>
            
            </div> */}
            <div className="footer-columns df mb1">
                <div className="footer-column">
                <div className="logo">
          <Link to={props.translation.nav[0].url}>
            <Logo></Logo>
            </Link>
        </div>
                </div>
                <div className="footer-column">
                    {/* <h4 className="color-accent-3">{ footerTexts.links }</h4> */}
                    {
                        nav.map(item => (
                        <Link key={item.title} to={item.url} className="footer-link">
                            {item.title}
                        </Link>
                        ))
                    }
                </div>
                <div className="footer-column">
                    {/* <h4 className="color-accent-2">{ footerTexts.contacts }</h4> */}
                    <div className="footer-contacts">
                      <OutboundLink href={instagram} target="_blank" rel="noreferrer" className="footer-link">
                          <span className="mr1"><FiInstagram className="icon color-gold"></FiInstagram></span>
                          Instagram
                      </OutboundLink>
                      <OutboundLink href={facebook} target="_blank" rel="noreferrer" className="footer-link">
                          <span className="mr1"><FiFacebook className="icon color-gold"></FiFacebook></span>
                          Facebook
                      </OutboundLink>
                      <OutboundLink href={pinterest} target="_blank" rel="noreferrer" className="footer-link">
                          <span className="mr1"><FaPinterestP className="icon color-gold"></FaPinterestP></span>
                          Pinterest
                      </OutboundLink>
                      <OutboundLink href={"mailto: "+email} target="_blank" rel="noreferrer" className="footer-link">
                          <span className="mr1"><FiMail className="icon color-gold"></FiMail></span>
                          Email
                      </OutboundLink>
                      <OutboundLink href={"tel: "+phone} target="_blank" rel="noreferrer" className="footer-link footer-link--icon">
                          <span className="mr1"><FiPhoneCall className="icon color-gold"/></span>
                          {phone}
                      </OutboundLink>
                      <OutboundLink href={googlemaplink} target="_blank" rel="noreferrer" className="footer-link footer-link--icon">
                          <span className="mr1"><FiMapPin className="icon color-gold"/></span>
                          {address}, {address2}
                      </OutboundLink>
                    </div>
                </div>
                <div className="footer-column">
                    {/* <h4 className="color-accent-1">{ footerTexts.lastposts }</h4> */}
                    {
                        posts.map((post)=>{
                            const slug = post.slug.split('.')[0];
                            const path = slugHandler(
                                props.lang,
                                slug
                              )
                            return (
                                <Link key={post.id} to={path} className="footer-link">
                                <span>{post.frontmatter.date}</span><br></br>
                                {post.frontmatter.title}
                                </Link>
                            )
                        })
                    }
                </div>

            </div>
            <div className="footer-copyright tac color-gold mb2">
              Designed &amp; coded by&nbsp;
              <OutboundLink href="https://www.linkedin.com/in/aseevaes" target="_blank" className="link" rel="noreferrer">
              Elena and Ivan Aseev 
              </OutboundLink>
              &nbsp;|&nbsp;
              Photos by&nbsp;
              <OutboundLink href="https://www.instagram.com/juliatima_" target="_blank" className="link" rel="noreferrer">
              Julia Tima
              </OutboundLink>&nbsp;
              &amp; &nbsp;
              <OutboundLink href="https://unsplash.com" target="_blank" className="link" rel="noreferrer">
              Unsplash
              </OutboundLink>&nbsp;
              <br></br>
              <Link to={slugHandler(props.lang, "privacy")} className="link">
                {props.translation.footer.privacy}
              </Link>
              &nbsp;|&nbsp;
               <span>© {year} { settings.sitename }</span> 
            </div>
            <CookieConsent translation={props.translation}></CookieConsent>
        </section>

    )
}

export default Footer